import { render } from "./Linda_page8.vue?vue&type=template&id=10f9c36e"
import script from "./Linda_page8.vue?vue&type=script&lang=js"
export * from "./Linda_page8.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__